/* eslint-disable no-useless-escape */
import axios from 'axios';

// Detect Device Type
function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'mobile';
    }
    return 'desktop';
}

// Detect Browser
function getBrowser() {
    const ua = navigator.userAgent;
    let browser = 'Unknown';

    if (ua.indexOf('Firefox') > -1) {
        browser = 'Firefox';
    } else if (ua.indexOf('SamsungBrowser') > -1) {
        browser = 'Samsung Internet';
    } else if (ua.indexOf('Opera') > -1 || ua.indexOf('OPR') > -1) {
        browser = 'Opera';
    } else if (ua.indexOf('Trident') > -1) {
        browser = 'Internet Explorer';
    } else if (ua.indexOf('Edge') > -1 || ua.indexOf('Edg') > -1) {
        browser = 'Edge';
    } else if (ua.indexOf('Chrome') > -1) {
        browser = 'Chrome';
    } else if (ua.indexOf('Safari') > -1) {
        browser = 'Safari';
    }

    return browser;
}

// Detect OS
function getOperatingSystem() {
    const ua = navigator.userAgent;
    let os = 'Unknown';

    if (ua.indexOf('Win') > -1) {
        os = 'Windows';
    } else if (ua.indexOf('Mac') > -1) {
        os = 'MacOS';
    } else if (ua.indexOf('Linux') > -1) {
        os = 'Linux';
    } else if (ua.indexOf('Android') > -1) {
        os = 'Android';
    } else if (ua.indexOf('like Mac') > -1) {
        os = 'iOS';
    }

    return os;
}

// Generate Session ID
function getSessionId() {
    let sessionId = sessionStorage.getItem('tracking_session_id');
    if (!sessionId) {
        sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem('tracking_session_id', sessionId);
    }
    return sessionId;
}

// Main tracking function
export function trackPageVisit(pageName) {
    const visitData = {
        page_name: pageName || document.title,
        page_url: window.location.href,
        device_type: getDeviceType(),
        browser: getBrowser(),
        operating_system: getOperatingSystem(),
        session_id: getSessionId(),
        language: navigator.language || navigator.userLanguage,
        screen_resolution: window.screen.width + 'x' + window.screen.height
    };

    // Send data
    const endpoint = '/api/v1/monitoring/track-visit/';

    axios.post(endpoint, visitData)
        .then(response => {
            // console.log('✅ Visit tracked successfully');
        })
        .catch(error => {
            console.error('❌ Error tracking visit:', error);
        });
}

// Visitor info helper
export function getVisitorInfo() {
    return {
        device_type: getDeviceType(),
        browser: getBrowser(),
        operating_system: getOperatingSystem(),
        session_id: getSessionId(),
        language: navigator.language || navigator.userLanguage,
        screen_resolution: window.screen.width + 'x' + window.screen.height,
        page_url: window.location.href,
        referrer: document.referrer
    };
}

// Expose globally for compatibility
window.trackPageVisit = trackPageVisit;
window.getVisitorInfo = getVisitorInfo;
